export default __webpack_public_path__ + "static/media/slider-img11.357ddf0e.jpg";